import { api } from './api'

export const dismissVerificationPrompt = (userId: number) =>
  api.delete(`/users/${userId}/verifications/prompt`)
